export enum PluginErrorExtensions {
  PLUGIN_ALREADY_ENABLED = 'PLUGIN_ALREADY_ENABLED',
  PLUGIN_TOO_MANY_PLUGINS = 'PLUGIN_TOO_MANY_PLUGINS',
  PLUGIN_NOT_ALLOWED = 'PLUGIN_NOT_ALLOWED',
}
